// ═══ A1 홈 데스크톱(≥1024) 2열 — 시안 C1 `.pgrid` (신고 371 §8) ═══
// 좌: 인사 → CTA 히어로(KPI 인라인) → 결정 대기 카드 2열 → 진행 중 밀도 행(최대 5).
// 우(.ss-sticky): 검차정산 요약 · 최근 종료 5 · 신청 방법 안내.
// 결정 2 — 인라인 [반려][매입 결정] 은 상세와 **같은 시트**(DecisionSheets)를 띄운다. 성공 시 목록만 재조회.
import React, { useState, useEffect } from 'react';
import { T, R, S } from '../../../theme';
import { useT } from '../../../../i18n/I18nProvider';
import { decideOrder, rejectOrder } from '../../api';
import { describeSimpleError } from '../../errors';
import { groupOf, isolate, stripTrailingChevron } from '../../fmt';
import SimpleCard from '../../parts/SimpleCard';
import LtrText from '../../parts/LtrText';
import ErrorText from '../../parts/ErrorText';
import { BuyPriceSheet, NotBuySheet } from '../requests/DecisionSheets';
import HeroStrip from './HeroStrip';
import DecisionCard from './DecisionCard';
import DenseRow from './DenseRow';
import HomeSide from './HomeSide';
import MethodStrip from './MethodStrip';

var hello = { marginBottom: 14 };
var helloName = { fontSize: 19, fontWeight: 800, letterSpacing: '-.4px', color: T.ink };
var helloSub = { fontSize: 12.5, color: T.sub, marginTop: 1 };
var colStyle = { minWidth: 0, display: 'flex', flexDirection: 'column', gap: 14 };
var sect = { display: 'flex', alignItems: 'center', gap: 9, fontSize: 11, fontWeight: 800, color: T.muted, letterSpacing: '.3px' };
var sectCount = {
  color: T.warn, background: T.warnTint, border: '1px solid ' + T.warnBd, borderRadius: R.pill,
  padding: '0 7px', fontSize: 11, fontWeight: 800
};
var dgrid = { display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 12 };
var moreRow = { padding: '9px 14px', borderTop: '1px solid ' + T.bdSoft, textAlign: 'center' };
var moreLink = { fontSize: 12, fontWeight: 700, color: T.accentPress, background: 'none', border: 0, cursor: 'pointer', fontFamily: 'inherit', padding: 0 };
// ARB 값 안의 '›' 는 RTL 에서 안 뒤집힌다 — 글리프를 떼고 .ss-flipx 스팬으로 붙인다(D7). transform 은 inline 에 안 먹는다.
var flipGlyph = { display: 'inline-block' };
var toastStyle = { position: 'fixed', insetInlineStart: 0, insetInlineEnd: 0, bottom: 28, zIndex: 9980, display: 'flex', justifyContent: 'center', pointerEvents: 'none' };
var toastBox = { maxWidth: 420, padding: '10px 16px', borderRadius: R.pill, background: T.ink, color: T.card, fontSize: 12.5, fontWeight: 600 };

function newestFirst(a, b) {
  var da = String((a && a.created_at) || ''), db = String((b && b.created_at) || '');
  if (da !== db) return da < db ? 1 : -1;
  return Number((b && b.id) || 0) - Number((a && a.id) || 0);
}

/// props: { name, orders, counts, active, settle, ordersError, onReload, onNavigate(path) }
function HomeDesktop(props) {
  var t = useT();
  var go = props.onNavigate;
  var onReload = props.onReload;
  var stSheet = useState(null); var sheet = stSheet[0], setSheet = stSheet[1];
  var stBusy = useState(false); var busy = stBusy[0], setBusy = stBusy[1];
  var stToast = useState(''); var toast = stToast[0], setToast = stToast[1];
  var stErr = useState(''); var actionErr = stErr[0], setActionErr = stErr[1];

  useEffect(function () {
    if (!toast) return undefined;
    var timer = setTimeout(function () { setToast(''); }, 3000);
    return function () { clearTimeout(timer); };
  }, [toast, setToast]);

  var run = function (promise, doneMsg) {
    setBusy(true);
    setActionErr('');
    promise.then(function () {
      setSheet(null);
      setBusy(false);
      setToast(doneMsg);
      onReload();
    }, function (e) {
      setSheet(null);
      setBusy(false);
      setActionErr(describeSimpleError(t, e));
    });
  };

  var orders = props.orders || [];
  var counts = props.counts || {};
  var active = props.active || [];
  var pending = orders.filter(function (o) { return groupOf(o && o.status) === 'actionNeeded'; }).sort(newestFirst);
  var finished = orders.filter(function (o) { return groupOf(o && o.status) === 'finished'; }).sort(newestFirst).slice(0, 5);
  var visible = active.slice(0, 5);
  var moreCount = active.length - visible.length;
  var openGroup = function (group) { go('/main/s/requests?group=' + group); };
  var openDetail = function (id) { go('/main/s/requests/' + id); };
  var openNew = function () { go('/main/s/request'); };

  return (<div className="ss-home">
    <div style={hello}>
      <div style={helloName}>{t('simpleB1Hello', { name: props.name })}</div>
      <div style={helloSub}>{t('simpleHelloSub')}</div>
    </div>

    <div className="ss-side">
      <div style={colStyle}>
        <HeroStrip counts={counts} onNew={openNew} onGroup={openGroup} />
        <MethodStrip onPick={function (m) { go('/main/s/request?method=' + m); }} />

        {props.ordersError ? <ErrorText>{describeSimpleError(t, props.ordersError)}</ErrorText> : null}
        <ErrorText>{actionErr}</ErrorText>

        {pending.length ? (<div className="ss-pending">
          <div style={sect}>
            {t('simpleGroupActionNeeded')}
            <LtrText style={sectCount}>{pending.length}</LtrText>
          </div>
          <div style={Object.assign({}, dgrid, { marginTop: 9 })}>
            {pending.map(function (o) {
              return (<DecisionCard key={o.id} order={o} busy={busy} onOpen={openDetail}
                onReject={function (id) { setSheet({ kind: 'notbuy', id: id }); }}
                onDecide={function (id) { setSheet({ kind: 'buy', id: id }); }} />);
            })}
          </div>
        </div>) : null}

        <SimpleCard title={t('simpleB1ActiveTitle')} count={visible.length}>
          {visible.length === 0 ? <div style={S.emptyText}>{t('simpleB1ActiveEmpty')}</div> : (<div>
            {visible.map(function (o, i) {
              return (<DenseRow key={o.id} order={o} first={i === 0}
                onClick={function () { openDetail(o.id); }} />);
            })}
            {moreCount > 0 ? (<div style={moreRow}>
              <button type="button" style={moreLink} onClick={function () { go('/main/s/requests'); }}>
                {stripTrailingChevron(t('simpleB1ActiveMore', { count: isolate(moreCount) }))}
                {' '}<span className="ss-flipx" aria-hidden="true" style={flipGlyph}>›</span>
              </button>
            </div>) : null}
          </div>)}
        </SimpleCard>
      </div>

      <div className="ss-sticky" style={colStyle}>
        <HomeSide settle={props.settle} finished={finished} finishedCount={counts.finished || 0}
          onFees={function () { go('/main/s/fees'); }} onGroup={openGroup} onOpen={openDetail} />
      </div>
    </div>

    <BuyPriceSheet open={!!sheet && sheet.kind === 'buy'} busy={busy} onClose={function () { setSheet(null); }}
      onConfirm={function (won) {
        if (!(won > 0) || !sheet) return;
        run(decideOrder(sheet.id, { purchase_price: won }), t('evalDecideDone'));
      }} />
    <NotBuySheet open={!!sheet && sheet.kind === 'notbuy'} busy={busy} onClose={function () { setSheet(null); }}
      onConfirm={function (ko) {
        if (!sheet) return;
        run(rejectOrder(sheet.id, ko), t('evalRejectDone'));
      }} />

    {toast ? <div style={toastStyle}><div role="status" style={toastBox}>{toast}</div></div> : null}
  </div>);
}

export default HomeDesktop;
